import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, fmtDate } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft } from "lucide-react";

export default function AdminUnidadeHistorico() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/unidades/${id}/historico`);
        setData(data);
      } catch { /* ignore */ }
    })();
  }, [id]);

  if (!data) return <div className="text-muted-foreground">Carregando histórico...</div>;

  const liq = data.liquidez_ponto_percent;
  const liqColor = liq >= 80 ? "text-success" : liq >= 50 ? "text-warning" : "text-destructive";

  return (
    <div className="space-y-8 fade-up">
      <Link to="/admin/unidades" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground">
        <ArrowLeft size={14} /> Voltar para unidades
      </Link>

      <div>
        <div className="label-tag mb-2">
          {data.unidade.tipo === "LOJA" ? "Loja" : "Estande Container"} · {data.unidade.metragem}m² · {data.unidade.frente.replace("_", " ")}
        </div>
        <h1 className="font-heading font-black tracking-tighter text-4xl sm:text-5xl">{data.unidade.numero_completo}</h1>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="stat-block p-6 rounded-sm">
          <div className="label-tag">Turnover histórico</div>
          <div className="stat-num text-4xl mt-3">{data.turnover_total}</div>
          <div className="text-xs text-muted-foreground mt-1">contratos totais</div>
        </div>
        <div className="stat-block p-6 rounded-sm">
          <div className="label-tag">Dias ocupada (total)</div>
          <div className="stat-num text-4xl mt-3">{data.total_dias_ocupada_historico}</div>
          <div className="text-xs text-muted-foreground mt-1">todos os contratos</div>
        </div>
        <div className="stat-block p-6 rounded-sm">
          <div className="label-tag">Dias vaga (ano atual)</div>
          <div className="stat-num text-4xl mt-3">{data.dias_vaga_ano_atual}</div>
          <div className="text-xs text-muted-foreground mt-1">janeiro até hoje</div>
        </div>
        <div className="stat-block p-6 rounded-sm">
          <div className="label-tag">Liquidez do ponto</div>
          <div className={`stat-num text-4xl mt-3 ${liqColor}`}>{liq}%</div>
          <div className="text-xs text-muted-foreground mt-1">dias ocupada / ano</div>
        </div>
      </div>

      <Card className="p-6 rounded-sm border-border">
        <h2 className="font-heading font-bold text-xl mb-6">Histórico de contratos</h2>
        {data.contratos.length === 0 ? (
          <div className="text-muted-foreground text-sm py-8 text-center border border-dashed rounded-sm">
            Nenhum contrato registrado para esta unidade.
          </div>
        ) : (
          <div className="space-y-2">
            {data.contratos.map((c) => (
              <div key={c.id} className="border border-border p-4 rounded-sm flex items-center justify-between">
                <div>
                  <div className="font-semibold">{c.razao_social}</div>
                  <div className="text-xs text-muted-foreground font-mono">{c.cnpj}</div>
                  <div className="text-xs text-muted-foreground mt-1">
                    {fmtDate(c.data_inicio)} → {fmtDate(c.data_fim)}
                  </div>
                </div>
                <div className="text-right">
                  <Badge variant={c.status === "ATIVO" ? "default" : "outline"} className="uppercase tracking-widest text-[10px]">
                    {c.status}
                  </Badge>
                  <div className="stat-num text-lg mt-2">{c.dias_ocupada}d</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
